import React from 'react'
import { Box, MenuItem, TextField, Typography } from '@mui/material'
import ValidationErrorText from '../common/ValidationErrorText'

const lpaOptions = [
  '0.5 LPA', '1 LPA', '1.5 LPA', '2 LPA', '2.5 LPA',
  '3 LPA', '3.5 LPA', '4 LPA', '4.5 LPA', '5 LPA',
  '6 LPA', '7 LPA', '8 LPA', '9 LPA', '10 LPA',
  '12 LPA', '15 LPA', '18 LPA', '20 LPA', '25 LPA',
  '30 LPA', '40 LPA', '50 LPA'
]

const defaultValue = {
  amountFrom: '',
  currencyFrom: '1 LPA',
  amountTo: '',
  currencyTo: '1 LPA'
}

const normalizeToNumber = (val) => {
  if (val === '' || val === null || val === undefined) return ''
  const num = Number(val)
  return isNaN(num) ? '' : num
}

const AveragePackageOffered = ({
  label,
  value = defaultValue,
  onChange,
  readOnly = false,
  fieldError,
  fieldErrors,
  fieldType
}) => {
  // Normalize incoming props to ensure numbers are stored
  const normalizedValue = {
    ...defaultValue,
    ...value,
    amountFrom: normalizeToNumber(value?.amountFrom),
    amountTo: normalizeToNumber(value?.amountTo),
  }

  const {
    amountFrom,
    currencyFrom,
    amountTo,
    currencyTo
  } = normalizedValue

  const [isFocusedFrom, setIsFocusedFrom] = React.useState(false)
  const [isFocusedTo, setIsFocusedTo] = React.useState(false)

  const handleFieldChange = (field, isNumber = false,updateField) => (e) => {
    let newValue = e.target.value
    if(String(newValue).includes('LPA') && updateField){
      newValue = parseInt()
    }
    if (isNumber) newValue = normalizeToNumber(newValue)
  
    onChange?.({
      ...normalizedValue,
      ...(String(newValue).includes('LPA') ? (field=="currencyFrom"  ? {amountFrom:parseFloat(newValue)*100000} : {amountTo:parseFloat(newValue)*100000}) :[]),
      [field]: newValue
    })
  }

  console.log("normalizedValue",normalizedValue);
  

  return (
    <>
      <Typography sx={{ fontSize: '16px', fontWeight: '500', mt: 2, mb: 1 }} fontWeight={600}>
        {label}
      </Typography>
      <ValidationErrorText error={fieldError}/>
    
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: 2 }}>
        
        {/* FROM */}
        <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            minWidth: 250,
            border: '1px solid',
            borderColor: isFocusedFrom ? 'primary.main' : '#ccc',
            borderRadius: 1,
            overflow: 'hidden',
            transition: 'border-color 0.2s ease-in-out',
          }}
        >
          <Box sx={{ px: 1.5, py: 0.75, backgroundColor: '#fff', fontSize: '14px', minWidth: 32, textAlign: 'center' }}>
            ₹
          </Box>
          <TextField
            variant="standard"
            InputProps={{ disableUnderline: true, readOnly }}
            size="small"
            placeholder="00"
            value={amountFrom}
            onChange={handleFieldChange('amountFrom', true)}
            onFocus={() => setIsFocusedFrom(true)}
            onBlur={() => setIsFocusedFrom(false)}
            sx={{ minWidth: 100, '& input': { px: 1, fontSize: 13, paddingBottom: '0' } }}
            inputProps={{ style: { fontSize: 13 }, type: 'number' }}
            disabled={readOnly}
          />
          <TextField
            select
            variant="standard"
            InputProps={{ disableUnderline: true, readOnly }}
            size="small"
            value={currencyFrom}
            onChange={handleFieldChange('currencyFrom')}
            onFocus={() => setIsFocusedFrom(true)}
            onBlur={() => setIsFocusedFrom(false)}
            sx={{
              minWidth: 80,
              '& .MuiSelect-select': { px: 1, fontSize: 13, paddingBottom: '0' },
            }}
            disabled={readOnly}
          >
            {lpaOptions.map((option) => (
              <MenuItem key={option} value={option} sx={{ fontSize: '13px' }}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Box>
          <ValidationErrorText error={fieldErrors?.[`${fieldType}.amountFrom`] || fieldErrors?.[`${fieldType}.currencyFrom`]}/>
        </Box>

        {/* TO LABEL */}
        <Typography sx={{ minWidth: 20, textAlign: 'center' }}>To</Typography>

        {/* TO */}
        <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            minWidth: 250,
            border: '1px solid',
            borderColor: isFocusedTo ? 'primary.main' : '#ccc',
            borderRadius: 1,
            overflow: 'hidden',
            transition: 'border-color 0.2s ease-in-out',
          }}
        >
          <Box sx={{ px: 1.5, py: 0.75, backgroundColor: '#fff', fontSize: '14px', minWidth: 32, textAlign: 'center' }}>
            ₹
          </Box>
          <TextField
            variant="standard"
            InputProps={{ disableUnderline: true, readOnly }}
            size="small"
            placeholder="00"
            value={amountTo}
            onChange={handleFieldChange('amountTo', true)}
            onFocus={() => setIsFocusedTo(true)}
            onBlur={() => setIsFocusedTo(false)}
            sx={{ minWidth: 100, '& input': { px: 1, fontSize: 13, paddingBottom: '0' } }}
            inputProps={{ style: { fontSize: 13 }, type: 'number' }}
            disabled={readOnly}
          />
          <TextField
            select
            variant="standard"
            InputProps={{ disableUnderline: true, readOnly }}
            size="small"
            value={currencyTo}
            onChange={handleFieldChange('currencyTo')}
            onFocus={() => setIsFocusedTo(true)}
            onBlur={() => setIsFocusedTo(false)}
            sx={{
              minWidth: 80,
              '& .MuiSelect-select': { px: 1, fontSize: 13, paddingBottom: '0' },
            }}
            disabled={readOnly}
          >
            {lpaOptions.map((option) => (
              <MenuItem key={option} value={option} sx={{ fontSize: '13px' }}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Box>
          <ValidationErrorText error={fieldErrors?.[`${fieldType}.amountTo`] || fieldErrors?.[`${fieldType}.currencyTo`]}/>
      
        </Box>
      </Box>
    </>
  )
}

export default AveragePackageOffered
